const TYPING_SELECTOR =
  'input, textarea, select, [contenteditable=""], [contenteditable="true"]';

type KeyEventLike = Pick<KeyboardEvent, 'target'> & {
  composedPath?: () => EventTarget[];
};

/**
 * Vrai quand la frappe a déjà un destinataire (champ de saisie, contenteditable).
 * Lit `composedPath()` : dans un shadow DOM, `target` vaut l'hôte et non le champ,
 * et un raccourci global avalerait la lettre.
 */
export function isTypingEvent(e: KeyEventLike): boolean {
  const origin = e.composedPath?.()[0] ?? e.target;
  const closest = (origin as { closest?: (sel: string) => unknown } | null)
    ?.closest;
  if (typeof closest !== 'function') return false;
  return !!closest.call(origin, TYPING_SELECTOR);
}
